const NON_WORKING_STATUSES = new Set(["failed", "stopped", "stopping"]);
const CONNECTING_STATUSES = new Set(["pending", "scan_qr_code", "starting"]);

function clean(value) {
  return String(value || "").trim();
}

function digits(value) {
  return clean(value).replace(/\D/gu, "");
}

function normalizedStatus(accountOrStatus) {
  return clean(typeof accountOrStatus === "object" ? accountOrStatus?.status : accountOrStatus).toLowerCase();
}

export function linkedAccountStatusLabel(status) {
  const normalized = normalizedStatus(status);
  if (normalized === "working") return "Working";
  if (CONNECTING_STATUSES.has(normalized)) return "Connecting";
  return "Not working";
}

export function accountVisibleIdentity(account = {}) {
  const phoneDigits = digits(account.phoneNumber || account.phone_number);
  if (phoneDigits) return `phone:${phoneDigits}`;
  const selfChatDigits = digits(clean(account.selfChatJid || account.self_chat_jid).split("@", 1)[0]);
  if (selfChatDigits) return `phone:${selfChatDigits}`;
  const accountId = clean(account.id);
  if (NON_WORKING_STATUSES.has(normalizedStatus(account))) {
    const hasBillingPath = account.hasCurrentPaidBilling || account.has_current_paid_billing;
    return hasBillingPath && accountId ? `billing:${accountId}` : "";
  }
  return accountId ? `account:${accountId}` : "";
}

function rankAccount(account = {}) {
  const normalized = normalizedStatus(account);
  const statusRank = normalized === "working"
    ? 0
    : CONNECTING_STATUSES.has(normalized)
      ? 1
      : NON_WORKING_STATUSES.has(normalized)
        ? 2
        : 3;
  return [statusRank, clean(account.id)];
}

function isBetterAccount(candidate = {}, current = {}) {
  const candidateRank = rankAccount(candidate);
  const currentRank = rankAccount(current);
  for (let index = 0; index < candidateRank.length; index += 1) {
    if (candidateRank[index] < currentRank[index]) return true;
    if (candidateRank[index] > currentRank[index]) return false;
  }
  return false;
}

export function visibleLinkedAccounts(accounts = []) {
  const byIdentity = new Map();
  for (const account of Array.isArray(accounts) ? accounts : []) {
    const identity = accountVisibleIdentity(account);
    if (!identity) continue;
    const current = byIdentity.get(identity);
    if (!current || isBetterAccount(account, current)) {
      byIdentity.set(identity, account);
    }
  }
  return [...byIdentity.values()];
}
